module.exports = __webpack_public_path__ + "img/other1.a37ed7d0.png";